import React from "react"
import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"

const CommunityViewLabels = ({ labels, systemLabels, isFetching }) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-status" />Labels
            </h3>
            <div className="tags">
                <ContentLoaderTags
                    isFetching={isFetching}
                    minTagLength={10}
                    maxTagLength={25}
                >
                    {labels.map(({ id, name }) => (
                        <div key={id} className="tag-item grey">
                            {name}
                        </div>
                    ))}
                    {(!labels || labels.length <= 0) && "No labels"}
                </ContentLoaderTags>
            </div>
            <h3>
                <span className="icon icon-status" />System Labels
            </h3>
            <div className="tags">
                <ContentLoaderTags
                    isFetching={isFetching}
                    tags={1}
                    tagLength={20}
                >
                    {systemLabels.map(label => (
                        <div key={label} className="tag-item grey">
                            {label}
                        </div>
                    ))}
                    {(!systemLabels || systemLabels.length <= 0) && "No labels"}
                </ContentLoaderTags>
            </div>
        </div>
    </div>
)

export default CommunityViewLabels
